namespace Portico.Models.Pdf {
    export class PdfRequest {
        public fileName: string;
        public template: string;
        public pdfContents: PdfContent[];

        constructor() {
            this.fileName = null;
            this.template = null;
            this.pdfContents = [];
        }
    }
}